<template>
  <a-modal 
    width="85%"
    :title="$t('global.personalTrack')"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
  >
    <MapTrack ref="mapTrack" :personInfo="personInfo"/>
  </a-modal>
</template>
<script>
import MapTrack from '@/components/MapTrack/MapTrack'
export default {
  components: {
    MapTrack
  },
  data () {
    return {
      visable: false,
      // personid: '',
      personInfo: ''
    }
  },
  methods: {
    handleOk () {
      this.visable = false
      this.$refs.mapTrack.stop()
    },
    handleCancel() {
      this.$refs.mapTrack.stop()
    },
    // 显示当前的modal本身
    async showModal (options) {
      // console.log(options)
      this.personInfo = options
      // this.personid = options.key
      this.visable = true
      // todo
    },
  }
}
</script>
